// Libraries

// Supermove
import {gql} from '@supermove/graphql';
import {useQuery} from '@supermove/hooks';

// Shared
import UserRole, {RoleType} from '@shared/modules/User/enums/UserRole';

const useViewerRoleQuery = () => {
  const {data, loading} = useQuery<{viewer: {id: string; role: RoleType}}>(ViewerRoleQuery, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    role: data?.viewer.role,
    isSuperAdmin: data?.viewer.role === UserRole.SUPER_ADMIN,
    loading,
  };
};

const ViewerRoleQuery = gql`
  query ViewerRoleQuery {
    ${gql.query}
    viewer {
      id
      role
    }
  }
`;

export default useViewerRoleQuery;
